import servicesUtils from "../../../utils/servicesUtils";
import { useMutation } from "react-query";

function useDefaultWorkspace() {
  return useMutation((id) => servicesUtils.getService(`/workspaces/${id}/default/`));
}

export default useDefaultWorkspace;
